import React from "react"
import Helmet from "react-helmet"
import "../../Main/Main.scss"
import TopBanner from "../../../components/TopBanner/TopBanner"
import PriceCalculator from "../../../components/PriceCalculator/PriceCalculator"
import LandingFeatures from "../../../components/LandingFeatures/LandingFeatures"
import LandingHelp from "../../../components/LandingHelp/LandingHelp"

class CityBugaevka extends React.Component {
    componentDidMount() {
        this.moveToHash()
    }

    moveToHash() {
        const hash = window.location.hash
        if ( hash ) {
            const element = document.querySelector(hash)
            if ( element ) {
                element.scrollIntoView({ behavior: "smooth" })
            }
        }
    }

    render() {
        return (
            <section className="Main City-Bugaevka">
                <Helmet>
                    <title>Такси Бугаёвка - Флика такси</title>
                    <meta name="description" content="Путешествуйте по Бугаёвке с уверенностью и комфортом! Наше такси готово обеспечить вас безопасными и удобными поездками по межгороду." />
                    <meta name="keywords" content="Такси, Бугаёвка, межгороднее такси, перевозки, надёжное такси, комфортное такси, заказ такси, безопасные поездки." />
                    <meta property="og:title" content="Такси Бугаевка" />
                    <meta property="og:description" content="Закажите надежное такси в Бугаевке для междугородних поездок с комфортными автомобилями и опытными водителями. Путешествуйте безопасно и удобно, оставляя заявку прямо сейчас!" />
                    <meta property="og:url" content="https://fleeka.ru/bugaevka/" />
                </Helmet>
                <TopBanner city={"КПП Бугаевка"} />
                <PriceCalculator />
                <LandingFeatures />
                <LandingHelp />
            </section>
        )
    }
}

export default CityBugaevka